function base64UrlEncode(input) {
    const bytes = typeof input === 'string'
        ? new TextEncoder().encode(input)
        : new Uint8Array(input);

    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

/**
 * Signs a JWT with HS256 using Web Crypto API (no external JWT package).
 * Payload matches aggregator: { userId, role } with 8h expiry.
 */
export async function generateAuthToken(userId, role) {
    const secret = (process.env.REACT_APP_JWT_SECRET || '').trim();
    if (!secret) {
        throw new Error('REACT_APP_JWT_SECRET is not configured');
    }

    const header = { alg: 'HS256', typ: 'JWT' };
    const now = Math.floor(Date.now() / 1000);
    const payload = {
        userId,
        role,
        iat: now,
        exp: now + 8 * 60 * 60,
    };

    const encodedHeader = base64UrlEncode(JSON.stringify(header));
    const encodedPayload = base64UrlEncode(JSON.stringify(payload));
    const dataToSign = `${encodedHeader}.${encodedPayload}`;

    const encoder = new TextEncoder();
    const key = await crypto.subtle.importKey(
        'raw',
        encoder.encode(secret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
    );

    const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(dataToSign));
    return `${dataToSign}.${base64UrlEncode(signature)}`;
}
